import { Button, Modal } from 'antd';
import { map } from 'lodash';
import React from 'react';
import { REPORT_NOTES } from '../../common/constants';

const ConfirmationModal = ({
  showModal = false,
  setShowModal,
  loading,
  mutationFunc = () => {},
}) => {
  const handleOk = () => {
    mutationFunc();
  };

  const handleCancel = () => {
    setShowModal(false);
  };
  return (
    <div id="confirmation-modal-container">
      <Modal
        id="confirmation-modal"
        maskClosable={false}
        centered
        closable={false}
        footer={null}
        open={showModal}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div id="modal-content">
          <h2 id="modal-title">Generate Download Link</h2>
          <p id="modal-description">
            Are you sure, you want to generate report download link and send to
            your registered email id?
          </p>
          <div id="modal-note">
            <b className="text-danger" id="note-label">
              Note:
            </b>
            <ul className="reports-note" id="reports-note-list">
              {map(REPORT_NOTES, (note) => (
                <li
                  key={note}
                  id={`note-item-${note.replace(/\s+/g, '-').toLowerCase()}`}
                >
                  {note}
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="form-buttons">
          <Button
            id="cancel-button"
            shape="round"
            className="cancel-button"
            onClick={handleCancel}
          >
            No, Cancel
          </Button>
          <Button
            id="generate-button"
            shape="round"
            className="save-button"
            onClick={handleOk}
            loading={loading}
            type="primary"
          >
            Yes, Generate
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default ConfirmationModal;
